import ChevronDownIcon from '@components/icons/chevron-down-icon';
import { v2_useAuthorizedCustomer } from '@crocodille/common';
import { useRouter } from '@framework/router';
import { Listbox } from '@headlessui/react';
import AppLayoutHeaderDivider from '@layouts/app-layout/app-layout-header-divider';
import { analyticsEvent } from '@modules/analytics';
import cn from 'classnames';
import { useCallback } from 'react';

import styles from './locale-switcher.module.scss';

const LocaleSwitcher: React.FC = () => {
  const { locale: currentLocale, locales = [], push, asPath } = useRouter();

  const { data: customer } = v2_useAuthorizedCustomer();

  const customerId = customer?.id;

  const handleChange = useCallback(
    (locale: string) => {
      push(asPath, undefined, { locale, scroll: false });

      if (customerId) {
        analyticsEvent('user_info', {
          lang: locale === 'cs' ? 'cs_CZ' : 'en_US',
          userId: customerId.toString(),
          userType: 'signed_in',
        });
      } else {
        analyticsEvent('user_info', {
          lang: locale === 'cs' ? 'cs_CZ' : 'en_US',
          userType: 'anonymous',
        });
      }
    },
    [push, asPath, customerId],
  );

  return (
    <>
      <div className={styles.container}>
        <Listbox
          as="div"
          value={currentLocale}
          onChange={handleChange}
          className={cn(styles.box)}
        >
          <Listbox.Button className={styles.button}>
            <span className={styles.label}>{currentLocale}</span>
            <ChevronDownIcon className={styles.icon} />
          </Listbox.Button>
          <Listbox.Options className={styles.options}>
            {locales.map((locale) => (
              <Listbox.Option
                key={locale}
                value={locale}
                className={styles.option}
              >
                {locale}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Listbox>
      </div>
      <AppLayoutHeaderDivider className={styles.divider} />
    </>
  );
};

export default LocaleSwitcher;
